import React , { useState, useEffect } from "react";
import { connect } from "react-redux";
import { signOut } from "../../actions/authAction";
import { Link } from "react-router-dom";

// import history from "../../history";
import { protectedAction } from "../../actions/authAction";

import { Layout, Row, Col, Button, Space, Modal } from "antd";
import { getClientPing, estimateSignalStrength } from "../../utils/networkUtils";

import Version from "./version.js";

import {
  ShoppingCartOutlined,
  PoweroffOutlined,
  HomeOutlined,
  UserOutlined,
  SettingFilled,
  WifiOutlined

} from "@ant-design/icons";

const { Header } = Layout;

const Navbar = ({ auth, signOut, protectedAction, Protected }) => {
  const [networkStatus, setNetworkStatus] = useState({
    ping: null,
    strength: "Checking...",
  });

  useEffect(() => {
    async function checkNetwork() {
      const ping = await getClientPing();
      const { strength, color } = estimateSignalStrength(ping);
      setNetworkStatus({ ping, strength, color });
    }

    checkNetwork();
    const interval = setInterval(checkNetwork, 5000);
    return () => clearInterval(interval);
  }, []);

  const SignOut = () => {
    signOut();
  };
  const ProtectedFunc = (Protected) => {
    protectedAction(!Protected);
  };

  return (
    <>
      <Header className="site-layout-background">
        <Row>
          <Col md={14} sm={1}>
            <Space size="large">
              {auth.isSignedIn ? (
                <>
                  <span onClick={() => ProtectedFunc(Protected)}>
                    Welcome {auth.email}
                  </span>

                  <span>
                    {" "}
                    <HomeOutlined /> {auth.profile.branchName}
                  </span>
                  <span>
                    {" "}
                    <UserOutlined /> {auth.profile.user_roleName}
                  </span>
                  <span style={{ fontWeight: 600, color: networkStatus.color }}>
                    <WifiOutlined /> {networkStatus.strength}{" "}
                    {networkStatus.ping && `(${networkStatus.ping} ms)`}
                  </span>
                </>
              ) : (
                ""
              )}
            </Space>
          </Col>
          <Col md={10} sm={24}>
            <Space size="large">
              <>
              <Col style={{ fontWeight: 600, color: "#706e6e" }}>
                <Link aria-current="page" to="/new-updated">
                  <Button type="secondary" icon={<SettingFilled />}>
                    v05.02.11
                  </Button>
                </Link>
                </Col>
                {/* <Link aria-current="page" to="/order/fast_pos">
                  <Button type="danger" icon={<ShoppingCartOutlined />}>
                    POS
                  </Button>
                </Link>
                <Link aria-current="page" to="/order/onlineorder">
                  <Button style={{color:"white", backgroundColor:"black"}} variant="solid" icon={<ShoppingCartOutlined />}>
                    Online
                  </Button>
                </Link> */}
              </>

              {/* <Link to="/login">
                <Button type="primary">Login</Button>
              </Link> */}
              {Protected ? (
                <Button
                  type="primary"
                  icon={<PoweroffOutlined />}
                  onClick={SignOut}
                  style={{ backgroundColor: "green" }}
                >
                  Sign Out
                </Button>
              ) : (
                <Button
                  type="primary"
                  icon={<PoweroffOutlined />}
                  onClick={SignOut}
                >
                  Sign Out
                </Button>
              )}
            </Space>
          </Col>
        </Row>
      </Header>

      {/* <Outlet /> */}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    Protected: state.auth.Protected,
  };
};

export default connect(mapStateToProps, { signOut, protectedAction })(Navbar);
